import { finalize } from 'rxjs/operators';
import { Component } from '@angular/core';
import { AuthService } from '../../app/auth.service';
import { BaseLoginComponent } from './base-login.component';
import { AppConfiguration } from '../conf/app.configuration';
import { AppState } from '../store/AppState';
import { Store } from '@ngrx/store';
import { SET_ACCESSMODE } from '../store/user';
// import { ActivatedRoute, ParamMap } from '@angular/router';

const SPIN_HIDDEN = 'hidden';
const SPIN_VISIBLE = 'visible';

@Component({
  selector: 'cert-login',
  templateUrl: 'cert-login-view.template.html'
})
export class CertLoginComponent extends BaseLoginComponent {
  errorMsg = '';
  public show_spin = SPIN_HIDDEN;

  modoMesaEnabled = false;
  modoAcceso = false;

  constructor(
    authService: AuthService,
    appConfig: AppConfiguration,
    public store: Store<AppState>
  ) {
    super(authService);
    this.modoMesaEnabled = appConfig.getValue('modo.mesa.enabled');
  }

  public onSubmit() {
    this.show_spin = SPIN_VISIBLE;
    this.subscribe(this.authService.certLogin().pipe(finalize(() => (this.show_spin = SPIN_HIDDEN))),
      result => {
        this.errorMsg = '';
        // IMPORTANTE: Si el login es correcto, establecer en sesión el modo de acceso
        let thisModoAcceso = this.modoAcceso;
        this.store.dispatch(SET_ACCESSMODE({ modoAcceso: thisModoAcceso }));
      },
      error => {
        this.errorMsg = this.getErrorResponse(
          error,
          'Certificado no válido.'
        );
      }
    );
  }
}
